import React from 'react'
import Navbar from '../inc/Navbar'
import Aboutus from './Aboutus'

function Aboutpage() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        <br/>
        <Aboutus/>
        <br/>
    </div>
  )
}

export default Aboutpage